<!--
 * @Author: wang.zhiqin wang.zhiqin@trs.com.cn
 * @Date: 2023-06-26 14:03:01
 * @LastEditors: wang.zhiqin wang.zhiqin@trs.com.cn
 * @LastEditTime: 2025-04-24 11:39:36
 * @FilePath: \jsczt\src\views\home.vue
 * @Description:
-->
<template>
  <div class="container" :style="{ zoom: scale }">
    <div class="content-wrapper">
      <top></top>
      <div class="current">当前位置：首页 > {{ cname }}</div>
      <div class="content">
        <div class="content_left">
          <leftTree :curnode="currNode" @curdata="getCurdata"></leftTree>
        </div>
        <div class="content_right">
          <div class="right_tab">
            <div class="year">
              <myYear
                v-if="year"
                @change="getYear"
                :year="year"
                @dateRange="getDateRange"
              ></myYear>
            </div>
            <div class="place" @click="dqDialog = true">
              <myRegions :value="curplace"></myRegions>
            </div>
            <div class="choose" @click="updateData">查询</div>
          </div>
          <div class="choice">
            <span style="margin-left: 20px">
              已选择:
              <span style="margin-left: 15px">年份:{{ showYear }}</span>
              <span style="margin-left: 15px">地区:{{ choicePlace }}</span>
            </span>
          </div>
          <!-- 列表 -->
          <normalList
            :list-data="listData"
            :deptList="0"
            :classinfoid="this.$route.query.classinfoid"
            :place="choicePlace"
            :year="year"
          ></normalList>
        </div>
        <div class="clear"></div>
      </div>
      <div class="footer">
        <div class="footercont">
          主办：江苏省财政厅 备案序号：苏ICP备15009401号
          公安备案号：32010602010331 网站标识码：3200000098 江苏省财政厅版权所有
          <div class="jiucuo">
            <span id="_span_jiucuo">
              <img @click="Link('3200000003')" style="border:0;cursor: pointer;" src="../assets/jiucuonew.png">
            </span>
          </div>
          <div class="dzjg">
            <span id="_ideConac">
              <a href="https://bszs.conac.cn/sitename?method=show&amp;id=105DF988641221CBE053012819ACE317" target="_blank">
                <img id="imgConac" vspace="0" hspace="0" border="0" src="../assets/red.png"></a>
              </span>
            </div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dqDialog"
      :append-to-body="true"
      class="my_dialog"
      style="background-color: none"
    >
      <choiceDialog
        v-if="dialogVisible"
        @curtext="getcurText"
        @close="getClose"
        :opentype="openType"
      ></choiceDialog>
    </el-dialog>
  </div>
</template>

<script>
import myYear from "../components/myYear.vue";
import myRegions from "../components/myRegions.vue";
import top from "../components/top.vue";
import normalList from "../components/normalList.vue";
import leftTree from "../components/leftTree.vue";
import choiceDialog from "../components/choiceDialog.vue";
export default {
  name: "overview",
  components: {
    myYear,
    myRegions,
    top,
    normalList,
    leftTree,
    choiceDialog,
  },
  data() {
    return {
      year: "",
      showYear: "",
      hasRange: false,
      // 当前节点
      currNode: "",
      // 节点名称
      cname: "",
      // 地区选择弹框
      dqDialog: false,
      // 地区内容
      dialogVisible: false,
      // 当前选中地区
      curplace: "",
      // 显示地区
      choicePlace: "",
      listData: [],
      areaCode: "",
      storageData: {},
      jsClassinfoid: ["28", "31", "18", "19", "20"],
      openType: "ys",
      scale: 1, // 初始缩放比例
    };
  },
  computed: {
    getWindowSize() {
      return {
        width: window.innerWidth,
        height: window.innerHeight,
      };
    },
  },
  watch: {
    dqDialog: {
      handler(val) {
        this.dialogVisible = val;
      },
      deep: true,
      immediate: true,
    },
    scale: {
      handler(val) {
        window.addEventListener("load", this.handleResize);
      },
      deep: true,
      immediate: true,
    },
    "$route.name": {
      handler(val) {
        this.handleResize();
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    window.addEventListener("load", this.handleResize);
    window.addEventListener("resize", this.handleResize);
  },
  methods: {
  Link (sitecode) {
    // 该站点需要纠错页面的url地址
    var url = "http://yjsgk.jsczt.cn/#/"
    // 跳转至纠错系统填写页面
    window.open('http://121.43.68.40/exposure/jiucuo.html?site_code=' + sitecode + '&url=' + encodeURIComponent(url))
  },
    handleResize() {
      var width = this.getWindowSize.width;
      // 假设你设计稿的宽度是 1920px
      var designWidth = 1920;
      var scale = width / designWidth;
      this.scale = scale.toFixed(2);
    },
    getClose(data) {
      if (data) {
        this.dqDialog = false;
      }
    },
    // 自定义年份
    getDateRange(date) {
      if (date.split(",")[0]) {
        this.hasRange = true;
        localStorage.setItem("rangeyear", date);
        // if (date.split(',')[0] < date.split(',')[1]) {
        //   localStorage.setItem('rangeyear', date.split(',')[1])
        // } else {
        //   localStorage.setItem('rangeyear', date.split(',')[0])
        // }
      }
    },
    // 当前左侧栏目
    getCurdata(item) {
      // console.log(item)
      // 清除头部的栏目名

      localStorage.setItem("topcname", "");
      this.currNode = item.classinfoid.toString();
      this.cname = item.cname;
      if (this.curplace === "") {
        if (this.storageData.code !== "") {
          this.curplace = this.storageData.place;
          this.areaCode = this.storageData.code;
        }
      }
      this.year = this.showYear;
      if (this.jsClassinfoid.includes(this.currNode)) {
        this.openType = "js";
      } else {
        this.openType = "ys";
      }
      // 更新路径数据
      var classinfoid = this.currNode;
      delete this.storageData.place;
      this.$router.push({
        name: "overView",
        query: { classinfoid, ...this.storageData },
      });
      this.getListdata();
      this.addData(item.classinfoid);
      // this.$http.post('/yjsUbas/yjs/add', {
      //   browserVersion:navigator.appVersion,
      //     browserName: navigator.appName,
      //     browserLanguage:navigator.language,
      //     areaCode:this.$route.query.code,
      //     areaName:this.choicePlace,
      //     // deptCode:item.deptcode,
      //     // deptName:item.deptname,
      //     // unitCode:"",
      //     // unitName:"",
      //     areaYear:this.$route.query.year,
      //     sourceType:6,
      //     fileType:item.classinfoid,
      //     url:window.location.href
      //   }).then(res => {
      //     // if (res.data.code === 200) {
      //       // this.listData = res.data.data
      //     }
      //   )
    },
    // 当前选中年份
    getYear(data) {
      this.hasRange = false;
      this.curplace = "";
      this.areaCode = "";
      this.year = data;
      if (data !== "自定义") {
        localStorage.setItem("year", data);
        localStorage.setItem("rangeyear", "");
      } else {
      }
    },
    // 当前选中地区
    getcurText(data) {
      this.curplace = data.chnldesc;
      this.areaCode = data.code;
      this.storageData.parentid = data.chnlid;
      if (data.close === false) {
        this.dqDialog = false;
      }
    },
    // 点击选择，更新值
    updateData() {
      this.showYear = this.year;
      this.choicePlace = this.curplace;
      this.storageData.year = this.showYear;
      this.storageData.place = this.curplace;
      this.storageData.code = this.areaCode;
      localStorage.setItem("key", JSON.stringify(this.storageData));
      // 更新路径数据
      var classinfoid = this.currNode;
      delete this.storageData.place;
      this.$router.push({
        name: "overView",
        query: { classinfoid, ...this.storageData },
      });
      this.getListdata();
    },
    async getListdata() {
      localStorage.setItem("ISdwname", 0);

      this.listData = [];
      if (this.areaCode === "") {
        this.$message({
          message: "行政区不能为空",
          type: "error",
        });
      } else {
        let listParams = {
          fileType: this.currNode,
          areaCode: this.areaCode,
          year: this.year,
        };
        if (this.year != "自定义") {
          listParams.year = this.year;
          await this.$http
            .post("/api/yjsgk/findDataByFileType", listParams, {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
            })
            .then((res) => {
              if (res.data.code === 200) {
                this.listData = res.data.data;
              }
            });
        } else {
          let Year = localStorage.getItem("rangeyear");
          listParams.year = Year;
          if (Year.split(",")[0] > Year.split(",")[1]) {
            this.$message({
              message: "开始时间不能大于结束时间",
              type: "error",
            });
          } else {
            await this.$http
              .post("/api/yjsgk/findDataByFileType", listParams, {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              })
              .then((res) => {
                if (res.data.code === 200) {
                  this.listData = res.data.data;
                }
              });
          }
        }
      }
    },
    // 数据初始值
    updateLocalStorageData() {
      this.storageData = JSON.parse(localStorage.getItem("key"));
      if (this.storageData) {
        if (this.storageData.year && this.storageData.year === "自定义") {
          this.year = localStorage.getItem("rangeyear");
          this.showYear = this.year;
        }
        // 左侧名称
        this.cname = localStorage.getItem("topcname")
          ? localStorage.getItem("topcname")
          : this.storageData.cname;
        // 地区
        this.curplace = this.storageData.place;
        this.areaCode = this.storageData.code;
        this.choicePlace = this.curplace;
        this.addData(this.$route.query.classinfoid);
      }

      // 列表数据
      this.getListdata();
    },
    isIdExists(treeData, code) {
      // 遍历树形数据的每个节点
      for (let i = 0; i < treeData.length; i++) {
        const node = treeData[i];
        if (node.code === code) {
          this.curplace = node.chnldesc;
          return true;
        }
        if (node.child && node.child.length > 0) {
          const isExists = this.isIdExists(node.child, code);
          if (isExists) {
            return true;
          }
        }
      }
      return false;
    },
    getcurArea() {
      this.$http
        .get("/api/wcmchannel/findxzqh", {
          params: {
            year: this.year=='自定义'?localStorage.getItem('rangeyear').split(",")[1]:this.year,
            openType: this.openType,
          },
        })
        .then((res) => {
          if (this.$route.query.code === res.data.data.code) {
            this.curplace = res.data.data.chnldesc;
          } else {
            this.isIdExists(res.data.data.child, this.$route.query.code);
          }
          this.choicePlace = this.curplace;
          var datas = {
            place: this.curplace,
            code: this.areaCode,
            year: this.year,
            parentid: this.$route.query.parentid,
          };
          // 存储路径上的值
          localStorage.setItem("key", JSON.stringify(datas));
          this.updateLocalStorageData();
        });
    },
  },
  created() {
    this.year = this.$route.query.year;
    this.currNode = this.$route.query.classinfoid;
    if (this.jsClassinfoid.includes(this.currNode)) {
      this.openType = "js";
    } else {
      this.openType = "ys";
    }
    this.areaCode = this.$route.query.code;
    this.showYear = this.year;
    this.getcurArea();
  },
};
</script>
<style scoped>
@import url("../assets/overview.css");
</style>



// WEBPACK FOOTER //
// src/views/overview.vue